import React, { Component } from 'react';

import SocialEnum from './SocialType';
import FacebookButton from "./social-buttons/FacebookButton";
import TwitterButton from "./social-buttons/TwitterButton";
import InstagramButton from "./social-buttons/InstagramButton";
import SnapchatButton from "./social-buttons/SnapchatButton";
import PinterestButton from "./social-buttons/PinterestButton";
import WhatsAppButton from "./social-buttons/WhatsappButton";
import LinkedinButton from "./social-buttons/LinkedinButton";
import EmailButton from "./social-buttons/EmailButton";
import CopyButton from "./social-buttons/CopyButton";

import {getIconsColorAsync, getSocialDataAsync, getStoreNameAsync} from '../../utils/StoreConfigManager';

const socialRegular = [[SocialEnum.INSTAGRAM, InstagramButton], [SocialEnum.FACEBOOK, FacebookButton], [SocialEnum.TWITTER, TwitterButton], [SocialEnum.SNAPCHAT, SnapchatButton], [SocialEnum.PINTEREST, PinterestButton],[SocialEnum.WHATSAPP, WhatsAppButton], [SocialEnum.Linkedin, LinkedinButton], [SocialEnum.Email, EmailButton], [SocialEnum.Copy, CopyButton]];
const socialReversed = [[SocialEnum.INSTAGRAM, InstagramButton], [SocialEnum.PINTEREST, PinterestButton], [SocialEnum.SNAPCHAT, SnapchatButton], [SocialEnum.TWITTER, TwitterButton], [SocialEnum.FACEBOOK, FacebookButton],[SocialEnum.WHATSAPP, WhatsAppButton]];

export default class Social extends Component {
    constructor(props) {
        super(props);

        this.state = {
            socialData: [],
            iconsColor: '#ffffff',
            storeName: 'Obsess'
        };
        this.mounted = false;
    }

    componentDidMount() {
        this.mounted = true;
        const socialPromise = getSocialDataAsync();
        const colorPromise = getIconsColorAsync();
        const namePromise = getStoreNameAsync();

        Promise.all([socialPromise, colorPromise, namePromise]).then((values) => {
            if (this.mounted) {
                this.setState({ socialData: values[0], iconsColor: '#ffffff', storeName: values[2] });
            }
        })
        .catch(error => console.error(error));
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        if (!this.state.socialData) {
            return (<React.Fragment/>);
        }
        const order = this.props.socialReversed ? socialReversed : socialRegular;
        const buttonStyle = this.props.socialReversed ? {marginLeft: '0.7em', top: '0.5em'} : {marginRight: '0.7em', bottom: '0.15em'}
        const containerStyle = this.props.socialReversed ? {marginRight: '0.5em'} : null;

        let socialData = this.state.socialData;
        socialData.push(
            {
                action: "profile",
                platform: "linkedin",
                share_copy: "",
                profile_url: {
                    path: "https://www.linkedin.com/company/salvatore-ferragamo/"
                }
            },
            {
                action: "profile",
                platform: "email",
                share_copy: "",
                profile_url: {
                    path: ""
                }
            },
            {
                action: "profile",
                platform: "copy",
                share_copy: "",
                profile_url: {
                    path: ""
                }
            },
            {
                action: "not profile",
                platform: "whatsapp",
                share_copy: "",
                profile_url: {
                    path: ""
                }
            }
            
        );
       
        const buttons = order.map(([platform, Button], index) => {
            console.log("social");
            const databasePlatform = socialData.find(dataPlatform => dataPlatform.platform === platform);
            const action = databasePlatform ? databasePlatform.action : null;
            let profileUrl = '';
            if(platform === 'email'){
                profileUrl = `mailto:?subject=Check out this new virtual store - Ferragamo&body=` + window.location.origin
            }else{
             profileUrl = databasePlatform && databasePlatform.profile_url ? databasePlatform.profile_url.path : null;
            }
            const shareCopy = databasePlatform && databasePlatform.share_copy ? databasePlatform.share_copy : 'Shop the ' + this.state.storeName + ' virtual store in 360 ';

            return action
                ? <Button
                    key={index}
                    style={buttonStyle}
                    color={this.state.iconsColor}
                    storeName={this.state.storeName}
                    action={action}
                    profileUrl={profileUrl}
                    shareCopy={shareCopy}
                />
                : <React.Fragment key={index}/>
        });

        return <span style={containerStyle}>{buttons}</span>
    }
}
